<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="homestay">
        <div class="card-horizontal__user d-flex">
            <div class="card-horizontal__user-left">

                <div v-if="homestay.view_mode === 'homestay'"  class="card-horizontal__user-photo">
                    <img :src="`/storage${homestay.images[0].path.replace('original', 'preview_l')}`" alt="" v-if="homestay.images.length">
                    <span v-text="getUserPM(homestay.name)"></span>
                </div>
                <a :href="`/volunteer/${homestay.user.id}/profile`" class="card-horizontal__user-photo" v-else>
                    <img :src="`/storage${homestay.user.avatar.path.replace('original', 'avatar')}`"  alt="" v-if="homestay.user.avatar">
                    <span v-text="getUserPM(homestay.user.name)"></span>
                </a>
                <div class="card-horizontal__user-paragraph d-flex">
                    <div class="card-horizontal__user-paragraph-title">{{$store.getters.t('homestays_reception_animals')}}:</div>
                    <span class="card-horizontal__user-paragraph-item">
                        {{homestay.reception_status === 'open' ? $store.getters.t('homestays_store_form_reception_open') : $store.getters.t('homestays_store_form_reception_closed')}}
                    </span>
                </div>
                    <div class="card-horizontal__user-paragraph d-flex" v-if="homestay.pet_categories.length">
                    <div class="card-horizontal__user-paragraph-title">{{$store.getters.t('homestays_category')}}:</div>
                    <span class="card-horizontal__user-paragraph-item" v-for="(category,idx) in homestay.pet_categories" :key="idx">
                        {{category.name}}{{ (homestay.pet_categories.length > 1 && idx !== (homestay.pet_categories.length - 1))? ',' : ''}} </span>
                </div>
            </div>
            <div class="card-horizontal__user-right">
                <div class="card-horizontal__user-location"><span class="lnr lnr-map-marker"></span>{{homestay.city.name}}</div>
                <div class="card-horizontal__user-name">
                    <div v-if="homestay.view_mode === 'homestay'">
                        {{homestay.name}}
                    </div>
                    <a :href="`/volunteer/${homestay.user.id}/profile`" v-else>
                        {{homestay.user.name}}
                    </a>
                </div>

                <div class="card-horizontal__user-descr" :style="{'-webkit-line-clamp': !openDescription ? 3 : 'unset'}" v-if="contentHeight > 66">


                    <template v-if="!openDescription">
                        <span class="card-horizontal__user-descr-content" v-html="homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='#' @click.prevent="openDescription = true" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_read_more')}}</a></span>
                    </template>
                    <template>
                        <span class="card-horizontal__user-descr-content" v-html="homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span> &nbsp;
                        <span><a href='#' @click.prevent="openDescription = false" class='card-horizontal__user-descr-more'>{{$store.getters.t('donors_card_collapse')}}</a></span>
                    </template>


                </div>
                <div class="card-horizontal__user-descr" v-else
                     v-html="(homestay.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, ''))">
                </div>

                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row d-flex">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--homestay"></span>
                        {{$store.getters.t(homestay.type === 'enclosure' ? 'homestays_type_enclosure' : 'homestays_type_apartment')}}
                    </div>
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--duration"></span>
                        {{homestay.min_duration}}{{(homestay.max_duration ? `-${homestay.max_duration}` : '')}}
                    </div>
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--charge"></span>
                        {{homestay.charge_category === 'paid_for' ? $store.getters.t('facilities_store_form_paid') : $store.getters.t('facilities_store_form_free')}}
                    </div>
                </div>

                <div class="card-horizontal__user-photos d-flex" v-if="homestay.images.length">


                    <a class="card-horizontal__user-photos-item" :class="{'card-horizontal__user-photos-item--block': idx < 3}"
                       v-for="(image, idx) in homestay.images" :href="`/storage${image.path}`"
                       :data-lightbox="'homestay-' + homestay.id"
                       :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>

                    <div class="card-horizontal__user-photos-item card-horizontal__user-photos-item--block d-flex" v-if="homestay.images.length > 3">
                        +{{homestay.images.length - 3}}
                    </div>

                </div>
                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row ">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <div class="card-horizontal__user-paragraph-title">
                            <span class="lnr lnr-map-marker"></span>{{$store.getters.t('homestays_address')}}:
                        </div>
                        {{homestay.street_address}}
                    </div>
                </div>

                <div class="card-horizontal__user-contact d-flex">
                    <a :href="`tel:${homestay.user.public_phone}`" v-if="homestay.user && homestay.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--icon">{{$store.getters.t('donors_card_call')}}</a>
                    <a href="#" @click.prevent="sendForm = !sendForm" v-if="user" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">{{$store.getters.t('donors_card_send_request')}}</a>
                    <a href="/auth/login" v-else class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">{{$store.getters.t('donors_card_send_request')}}</a>
                    <a href="#" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--danger" v-if="user.id === homestay.user_id" @click.prevent="deleteHomestay">{{$store.getters.t('facilities_card_delete')}}</a>
                </div>

                <transition name="slide">

                    <card-horizontal-form :user="user" :send-obj="homestay" page="homestays" :self-pets="pets" v-if="sendForm" />

                </transition>


            </div>
        </div>
    </div>
</template>

<script>

import CardHorizontalForm from "../CardHorizontalForm";

export default {
    name: "CardHorizontal",
    props: ['homestay', 'index', 'user', 'pets'],
    components:{
        CardHorizontalForm,
    },
    data(){
        return{
            sendForm: false,
            contentHeight: 0,
            media: null,
            openDescription: false,
        }
    },
    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },
    mounted(){
        this.getContent(this.index)
    },

    watch:{
        media() {
            this.getContent(this.index)
        },
    },
    methods:{
        deleteHomestay(){
            if (confirm(this.$store.getters.t('facilities_card_confirm_delete'))) {
                axios.delete(`/api/homestays/${this.homestay.id}`).then(response => {
                    this.$emit('deleted')
                });
            }
        },

        myEventHandler(e){
            this.media = window.innerWidth
        },

        getContent(index){

            if(typeof index !== 'number') return this.contentHeight = 0

            let descr = document.querySelector(`.card-horizontal__${index} .card-horizontal__user-descr`).scrollHeight

            this.contentHeight = descr
        },

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }





}
</script>

<style lang="scss" scoped>
    .slide-enter-active {
        -moz-transition-duration: 0.2s;
        -webkit-transition-duration: 0.2s;
        -o-transition-duration: 0.2s;
        transition-duration: 0.2s;
        -moz-transition-timing-function: ease;
        -webkit-transition-timing-function: ease;
        -o-transition-timing-function: ease;
        transition-timing-function: ease;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.2s;
        -webkit-transition-duration: 0.2s;
        -o-transition-duration: 0.2s;
        transition-duration: 0.2s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to, .slide-leave {
        max-height: 100px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }
</style>
